import { cn } from "@/lib/utils";

const sizeMap = {
  sm: { dim: 24, text: "text-sm" },
  md: { dim: 32, text: "text-base" },
  lg: { dim: 40, text: "text-lg" },
} as const;

interface LogoProps {
  size?: keyof typeof sizeMap;
  showText?: boolean;
  className?: string;
}

export function Logo({ size = "md", showText, className }: LogoProps) {
  const { dim, text } = sizeMap[size];
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <img
        src="/brand/logo192.png"
        alt="健身館管理後台"
        width={dim}
        height={dim}
        className="shrink-0 rounded-md"
      />
      {showText && <span className={cn("font-semibold text-ink-900 tracking-tight", text)}>健身館後台</span>}
    </div>
  );
}
